export function GetProductConfig () {
  if (window.productConfig) {
    return {
      productId: window.productConfig.productId,
      productPicture: window.productConfig.productPicture
    }
  }

  return {}
}



// WEBPACK FOOTER //
// ./src/config/productConfig.js